import axios from 'axios';
import * as apiConstant from './apiConstant';

/****************************************
    destination management API
    @author  JKS015
    @date    2020.5.13
    @version 0.1    
 ******************************************/
class destinationApi {
  static getDestinationArea(page) {
    var lang_key = localStorage.getItem('language');
    return axios({
      url: `${apiConstant.API_URL}/destination/${(lang_key === undefined || lang_key === null) ? 'en' : lang_key}?index=${page * 8}`,
      method: 'GET',
      headers: {
        'accept': 'application/json'
      }
    })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        throw error;
      });
  }

  static getDestination(id) {
    var lang_key = localStorage.getItem('language');
    return axios({
      url: `${apiConstant.API_URL}/destination/${(lang_key === undefined || lang_key === null) ? 'en' : lang_key}/${id}`,
      method: 'GET',
      headers: {
        'accept': 'application/json'
      }
    })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        throw error;
      });
  }

  static getOtherDestinationArea(id) {
    var lang_key = localStorage.getItem('language');
    return axios({
      url: `${apiConstant.API_URL}/destination/others/${(lang_key === undefined || lang_key === null) ? 'en' : lang_key}?t=${id}`,
      method: 'GET',
      headers: {
        'accept': 'application/json'
      }
    })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        throw error;
      });
  }

  static getDestinationPlace(destinationId, curPage, searchKey) {
    var lang_key = localStorage.getItem('language');
    var urlMe = `${apiConstant.API_URL}/place/paginate/${(lang_key === undefined || lang_key === null) ? 'en' : lang_key}/?des=${destinationId}&page=${curPage}`;
    urlMe += searchKey.length === 0 ? '' : `&search=${searchKey}`;
    return axios({
      url: urlMe,
      method: 'GET',
      headers: {
        'accept': 'application/json'
      }
    })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        throw error;
      });
  }

  static getPlaceType(destinationId) {
    var lang_key = localStorage.getItem('language');
    return axios({
      url: `${apiConstant.API_URL}/placetype/${(lang_key === undefined || lang_key === null) ? 'en' : lang_key}/?des=${destinationId}`,
      method: 'GET',
      headers: {
        'accept': 'application/json'
      }
    })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        throw error;
      });
  }

  static getPlaceByType(destinationId, typeID, curPage, searchKey) {
    var lang_key = localStorage.getItem('language');
    var urlMe = `${apiConstant.API_URL}/place/paginate/${(lang_key === undefined || lang_key === null) ? 'en' : lang_key}/?des=${destinationId}&type=${typeID}&page=${curPage}`;
    urlMe += searchKey.length === 0 ? '' : `&search=${searchKey}`;
    return axios({
      url: urlMe,
      method: 'GET',
      headers: {
        'accept': 'application/json'
      }
    })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        throw error;
      });
  }

  static getDestinationService(destinationId, typeID) {
    var lang_key = localStorage.getItem('language');
    return axios({
      url: `${apiConstant.API_URL}/srv/${(lang_key === undefined || lang_key === null) ? 'en' : lang_key}?des=${destinationId}`,
      method: 'GET',
      headers: {
        'accept': 'application/json'
      }
    })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        throw error;
      });
  }

  static getPlace(placeID) {
    var lang_key = localStorage.getItem('language');
    return axios({
      url: `${apiConstant.API_URL}/place/${(lang_key === undefined || lang_key === null) ? 'en' : lang_key}/${placeID}`,
      method: 'GET',
      headers: {
        'accept': 'application/json'
      }
    })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        throw error;
      });
  } getOtherPlace

  static getOtherPlace(destinationID, placeID) {
    var lang_key = localStorage.getItem('language');
    return axios({
      url: `${apiConstant.API_URL}/place/others/${(lang_key === undefined || lang_key === null) ? 'en' : lang_key}?des=${destinationID}&t=${placeID}`,
      method: 'GET',
      headers: {
        'accept': 'application/json'
      }
    })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        throw error;
      });
  } 

  static getService(serviceID) {
    var lang_key = localStorage.getItem('language');
    return axios({
      url: `${apiConstant.API_URL}/srv/${(lang_key === undefined || lang_key === null) ? 'en' : lang_key}/${serviceID}`,
      method: 'GET',
      headers: {
        'accept': 'application/json'
      }
    })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        throw error;
      });
  }

  static getOtherServices(destinationID, serviceID) {
    var lang_key = localStorage.getItem('language');
    return axios({
      url: `${apiConstant.API_URL}/srv/others/${(lang_key === undefined || lang_key === null) ? 'en' : lang_key}?des=${destinationID}&t=${serviceID}`,
      method: 'GET',
      headers: {
        'accept': 'application/json'
      }
    })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        throw error;
      });
  }

  static getDestinationExperience(business, id) {
    var lang_key = localStorage.getItem('language');
    return axios({
      url: `${apiConstant.API_URL}/experience/paginateByBs/${(lang_key === undefined || lang_key === null) ? 'en' : lang_key}?bs=${business}&bsId=${id}`,
      method: 'GET',
      headers: {
        'accept': 'application/json'
      }
    })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        throw error;
      });
  }
}

export default destinationApi;